var _rect, _rect2, _g, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSectionMap1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 122,
    viewBox: "0 0 171 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 1.84122,
    y: 1.84122,
    width: 59.3176,
    height: 118.318,
    fill: "#6BDD35",
    fillOpacity: 0.4,
    stroke: "#6BDD35",
    strokeWidth: 3.68244
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_309_399",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 63,
    height: 122
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 122,
    fill: "#6BDD35"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_309_399)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 18,
    r: 18,
    fill: "#4F9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 21,
    r: 18,
    fill: "#4F9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 18,
    r: 18,
    fill: "#4F9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 16,
    r: 29,
    fill: "#4F9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 18,
    r: 29,
    fill: "#4F9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 20,
    r: 29,
    fill: "#4F9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 27,
    r: 29,
    fill: "#4F9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 18,
    r: 29,
    fill: "#4F9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 21,
    r: 29,
    fill: "#4F9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 23,
    r: 29,
    fill: "#4F9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 27,
    r: 29,
    fill: "#4F9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 113.5,
    r: 26.5,
    fill: "#4F9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 107.5,
    r: 26.5,
    fill: "#4F9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 103.5,
    r: 26.5,
    fill: "#4F9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 103.5,
    r: 19.5,
    fill: "#4F9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 102.5,
    r: 19.5,
    fill: "#4F9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 108.5,
    r: 19.5,
    fill: "#4F9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 108.5,
    r: 19.5,
    fill: "#4F9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 108.5,
    r: 19.5,
    fill: "#4F9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 92.5,
    r: 11.5,
    fill: "#4F9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 87.5,
    r: 11.5,
    fill: "#4F9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 86.5,
    r: 11.5,
    fill: "#4F9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 85.5,
    r: 14.5,
    fill: "#4F9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 84.5,
    r: 14.5,
    fill: "#4F9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 82.5,
    r: 14.5,
    fill: "#4F9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -3.5,
    cy: 78.5,
    r: 14.5,
    fill: "#4F9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -3.5,
    cy: 78.5,
    r: 14.5,
    fill: "#4F9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 100.5,
    r: 14.5,
    fill: "#4F9534",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 18,
    r: 18,
    fill: "#4F9534",
    fillOpacity: 0.1
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M141.141 30.1562C138.555 30.1562 136.703 28.7969 136.703 26.9531C136.703 25.5312 137.797 24.375 139.203 24.1562V24.0781C137.977 23.8438 137.133 22.8203 137.141 21.5781C137.133 19.8203 138.828 18.5312 141.141 18.5312C143.453 18.5312 145.148 19.8203 145.156 21.5781C145.148 22.8203 144.281 23.8438 143.094 24.0781V24.1562C144.469 24.375 145.578 25.5312 145.578 26.9531C145.578 28.7969 143.719 30.1562 141.141 30.1562ZM139.156 26.7188C139.148 27.6875 139.945 28.3672 141.141 28.3594C142.336 28.3672 143.133 27.6875 143.125 26.7188C143.133 25.7422 142.289 25.0234 141.141 25.0156C139.992 25.0234 139.148 25.7344 139.156 26.7188ZM139.438 21.8125C139.43 22.7188 140.141 23.3516 141.141 23.3594C142.133 23.3516 142.852 22.7188 142.859 21.8125C142.852 20.9297 142.148 20.3125 141.141 20.3125C140.125 20.3125 139.43 20.9297 139.438 21.8125ZM147.625 30L152.391 20.6875V20.6094H146.844V18.6875H154.828V20.6406L150.062 30H147.625ZM159.359 24.3438C157.664 24.3438 156.75 23.1094 156.75 21.3281C156.75 19.5391 157.711 18.2969 159.359 18.2969C161.055 18.2969 161.961 19.5391 161.969 21.3281C161.961 23.125 161.031 24.3438 159.359 24.3438ZM158.344 21.3281C158.352 22.3047 158.703 22.9453 159.359 22.9531C160.031 22.9453 160.367 22.3047 160.375 21.3281C160.367 20.3516 160.062 19.6875 159.359 19.6875C158.695 19.6953 158.352 20.3672 158.344 21.3281ZM158.375 30L166.156 18.6875H167.906L160.125 30H158.375ZM164.391 27.3594C164.391 25.5703 165.352 24.3359 166.984 24.3281C168.695 24.3359 169.602 25.5703 169.609 27.3594C169.602 29.1562 168.672 30.375 166.984 30.375C165.305 30.375 164.391 29.1406 164.391 27.3594ZM165.984 27.3594C165.992 28.3359 166.344 28.9844 166.984 28.9844C167.672 28.9844 168.008 28.3359 168.016 27.3594C168.008 26.3828 167.695 25.7188 166.984 25.7344C166.328 25.7266 165.992 26.3984 165.984 27.3594Z",
    fill: "#CDD0DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M140.966 96.3945V107H139.34V98.0059H139.281L136.747 99.6611V98.123L139.384 96.3945H140.966ZM147.353 107.146C144.899 107.146 143.456 105.169 143.456 101.697C143.456 98.2476 144.914 96.248 147.353 96.248C149.784 96.248 151.242 98.2476 151.249 101.697C151.242 105.169 149.806 107.146 147.353 107.146ZM145.067 101.697C145.06 104.341 145.917 105.755 147.353 105.755C148.781 105.755 149.638 104.341 149.638 101.697C149.638 99.0605 148.773 97.6177 147.353 97.6104C145.924 97.6177 145.067 99.0605 145.067 101.697ZM155.351 101.434C153.9 101.448 153.109 100.372 153.124 98.7969C153.109 97.2441 153.937 96.1675 155.351 96.1748C156.808 96.1675 157.57 97.2441 157.577 98.7969C157.57 100.379 156.779 101.448 155.351 101.434ZM154.325 107L161.605 96.3945H162.938L155.658 107H154.325ZM154.325 98.7969C154.333 99.771 154.669 100.401 155.351 100.408C156.039 100.401 156.361 99.771 156.361 98.7969C156.361 97.8447 156.061 97.1929 155.351 97.2002C154.669 97.2148 154.333 97.8521 154.325 98.7969ZM159.818 104.583C159.811 103.016 160.631 101.939 162.045 101.946C163.495 101.939 164.264 103.016 164.271 104.583C164.264 106.15 163.473 107.22 162.045 107.22C160.602 107.22 159.811 106.143 159.818 104.583ZM161.02 104.583C161.027 105.542 161.364 106.18 162.045 106.18C162.733 106.18 163.056 105.542 163.056 104.583C163.056 103.616 162.755 102.972 162.045 102.972C161.371 102.986 161.027 103.624 161.02 104.583Z",
    fill: "#CDD0DA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3887 85.1367C93.3379 85.1367 91.8818 84.0361 91.8203 82.416H93.3516C93.4062 83.2842 94.2676 83.8379 95.375 83.8379C96.5713 83.8379 97.4395 83.1885 97.4395 82.2246C97.4395 81.2471 96.626 80.5498 95.2109 80.543H94.3633V79.3125H95.2109C96.3389 79.3193 97.125 78.6904 97.125 77.7402C97.125 76.8379 96.4482 76.2227 95.4023 76.2227C94.4111 76.2227 93.5225 76.7764 93.4883 77.6719H92.0391C92.0801 76.0586 93.5703 74.9648 95.416 74.9648C97.3643 74.9648 98.5879 76.1953 98.5742 77.6582C98.5879 78.7861 97.8906 79.5928 96.8242 79.8594V79.9277C98.1777 80.1191 98.9639 81.0283 98.957 82.2793C98.9639 83.9268 97.4395 85.1367 95.3887 85.1367ZM102.881 79.8047C101.527 79.8184 100.789 78.8135 100.803 77.3438C100.789 75.8945 101.562 74.8896 102.881 74.8965C104.241 74.8896 104.952 75.8945 104.959 77.3438C104.952 78.8203 104.214 79.8184 102.881 79.8047ZM101.924 85L108.719 75.1016H109.963L103.168 85H101.924ZM101.924 77.3438C101.931 78.2529 102.245 78.8408 102.881 78.8477C103.523 78.8408 103.824 78.2529 103.824 77.3438C103.824 76.4551 103.544 75.8467 102.881 75.8535C102.245 75.8672 101.931 76.4619 101.924 77.3438ZM107.051 82.7441C107.044 81.2812 107.81 80.2764 109.129 80.2832C110.482 80.2764 111.2 81.2812 111.207 82.7441C111.2 84.207 110.462 85.2051 109.129 85.2051C107.782 85.2051 107.044 84.2002 107.051 82.7441ZM108.172 82.7441C108.179 83.6396 108.493 84.2344 109.129 84.2344C109.771 84.2344 110.072 83.6396 110.072 82.7441C110.072 81.8418 109.792 81.2402 109.129 81.2402C108.5 81.2539 108.179 81.8486 108.172 82.7441Z",
    fill: "#CDD0DA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M125.333 25C125.333 26.4728 126.527 27.6667 128 27.6667C129.473 27.6667 130.667 26.4728 130.667 25C130.667 23.5272 129.473 22.3333 128 22.3333C126.527 22.3333 125.333 23.5272 125.333 25ZM29.3333 25C29.3333 26.4728 30.5272 27.6667 32 27.6667C33.4728 27.6667 34.6667 26.4728 34.6667 25C34.6667 23.5272 33.4728 22.3333 32 22.3333C30.5272 22.3333 29.3333 23.5272 29.3333 25ZM128 24.5H32V25.5H128V24.5Z",
    fill: "#CDD0DA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3333 81C81.3333 82.4728 82.5272 83.6667 84 83.6667C85.4728 83.6667 86.6667 82.4728 86.6667 81C86.6667 79.5272 85.4728 78.3333 84 78.3333C82.5272 78.3333 81.3333 79.5272 81.3333 81ZM7.33333 81C7.33333 82.4728 8.52724 83.6667 10 83.6667C11.4728 83.6667 12.6667 82.4728 12.6667 81C12.6667 79.5272 11.4728 78.3333 10 78.3333C8.52724 78.3333 7.33333 79.5272 7.33333 81ZM84 80.5L10 80.5L10 81.5L84 81.5L84 80.5Z",
    fill: "#CDD0DA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M124.333 102C124.333 103.473 125.527 104.667 127 104.667C128.473 104.667 129.667 103.473 129.667 102C129.667 100.527 128.473 99.3333 127 99.3333C125.527 99.3333 124.333 100.527 124.333 102ZM43.3333 102C43.3333 103.473 44.5272 104.667 46 104.667C47.4728 104.667 48.6667 103.473 48.6667 102C48.6667 100.527 47.4728 99.3333 46 99.3333C44.5272 99.3333 43.3333 100.527 43.3333 102ZM127 101.5L46 101.5L46 102.5L127 102.5L127 101.5Z",
    fill: "#CDD0DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionMap1);
export default __webpack_public_path__ + "static/media/Section_map_1.781dddd43f5c032a4ba1b01b7c89655b.svg";
export { ForwardRef as ReactComponent };